import { withBoundaries } from '../../hoc';
import { PdfViewerWidgetComponent } from './PdfViewerWidget';
export default withBoundaries(PdfViewerWidgetComponent);